<template>
  <modal class="modal--welcomeback modal--zero-balance" :modal-key="'invite_friend_personalize_modal'" @close="$emit('close')" :body-style="'invitation'">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_invite_friend_title }}</h1>
      <img class="pinicon" src="static/images/invite_icon.svg" alt="">
    </template>
    <template slot="body">
      <p></p>
      <h2 class="modal_sub">{{ getTranslations.home_modals_invite_personalize_description }}</h2>
      <form-field :placeholder-text="getTranslations.home_modals_invite_personalize_type_name"
                  :submit-text="''"
                  :extra-class="'phone_input'"
                  :has-errors="name.hasErrors"
                  :has-success="name.hasSuccess"
                  :error-text="getTranslations.home_modals_invite_friend_mobile_error"
                  :success-text="getTranslations.home_modals_invite_friend_success"
                  :has-submit="false"
                  @input="updateName"
                  :action-on-click="null"/>
      <div class="modal__footer footer_buttons">
        <a href="#"
           class="btn2  btn2--outline btn2--small"
           @click.prevent="invite()">
          {{ getTranslations.home_modals_invite_personalize_skip }}
        </a>
        <a href="#"
           :class="['btn2', 'btn2--std btn2--small btn2--std', { deactivated: name.hasErrors }]"
           @click.prevent="invite()">
          {{ getTranslations.home_modals_invite_personalize_invite }}
        </a>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import FormField from '../../shared/FormField';

export default {
  name: 'invite-friend-personalize',
  components: {
    Modal,
    FormField,
  },
  props: {
    info: Object,
  },
  data() {
    return {
      input: '',
      name: {
        hasErrors: false,
        hasSuccess: false,
      },
    };
  },
  methods: {
    ...mapActions('profile', [
      'sendFriendInvitation',
    ]),
    updateName(input) {
      this.input = input;
    },
    invite() {
      const payload = {
        ...this.info,
        name: this.input,
      };
      this.sendFriendInvitation(payload).then((response) => {
        if (response.data.responseEnum === 'MSISDN_INVALID' || response.data.responseEnum === 'SERVER_ERROR') {
          this.$emit('error');
        } else {
          this.$emit('close');
        }
      });
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/users/InviteFriendPersonalize.vue